(function () {
    'use strict';

    angular
        .module('harriApp')
        .service('userBusinessesService', UserBusinessesService);

    function UserBusinessesService($q) {
        const self = this;

        let _employeeBusinesses;

        self.getUserBusinesses = function () {
            const defer = $q.defer();
            if (_employeeBusinesses) {
                defer.resolve(_employeeBusinesses);
            } else {
                TeamAPI.getEmployeeBusinesses()
                    .then(function (brands) {
                        _employeeBusinesses = brands;
                        defer.resolve(_employeeBusinesses);
                    });
            }
            return defer.promise;
        };

        self.doesUserHaveService = (userBrands, serviceName) => {
            for (const brand of userBrands) {
                if (brand.services.includes(serviceName)) {
                    return true;
                }
            }
            return false;
        }

    }

    UserBusinessesService.$inject = ['$q'];

})();
